// extracted by mini-css-extract-plugin
module.exports = {"stepsGrid":"SetupReviewerPayment_stepsGrid__1087P","stepNumber":"SetupReviewerPayment_stepNumber__AIwes","stepNumberSelected":"SetupReviewerPayment_stepNumberSelected__2Gm77"};